<div class="breadcrumbWrapper">
  <app-breadcrumb [inputbreadcrumbs]="breadcrumbs"></app-breadcrumb>
</div>
<div class="page-contents">

  <div class="levelOne-full-container" id='levelOne'>
    <div class="entry-container">
      <app-kbtemplate></app-kbtemplate>
    </div>
  </div>
</div>